import React from "react";
import useDataStore from "../../../../stores/dataStore";
import ContextMenuItem from "../../ContextMenuItem";
import { useTheme } from "../../../../context/useThemeContext";
import useAbsoluteWindowStore from "../../../../stores/absoluteWindowStore";

function ChangeFolderContextMenu(props: { noteID: string }) {
    const folders = useDataStore((state) => state.data.folders);
    const filteredFolders = Object.fromEntries( // if there's an id of undefined, remove it
        Object.entries(folders).filter((folder) => folder[1].id)
    );

    return (
        <div>
            <FolderContextItem
                noteID={props.noteID}
                folderID={undefined}
                key={"uncategorized"}
            />
            {Object.keys(filteredFolders).map((folderId) => {
                return (
                    <FolderContextItem
                        noteID={props.noteID}
                        folderID={folderId}
                        key={folderId}
                    />
                );
            })}
        </div>
    );
}

export default ChangeFolderContextMenu;

function FolderContextItem(props: {
    noteID: string;
    folderID: string | undefined;
}) {
    const { theme } = useTheme();
    const folderData = useDataStore((state) =>
        props.folderID ? state.data.folders[props.folderID] : undefined
    );
    const noteFolder = useDataStore(
        (state) => state.data.notes[props.noteID]?.folderID
    );

    return (
        <div>
            <ContextMenuItem
                label={folderData?.name || "Uncategorized"}
                icon={
                    <div
                        className="h-[10px] w-[10px] rounded-full"
                        style={{
                            backgroundColor:
                                folderData?.color !== undefined
                                    ? theme.accentColors[folderData.color]
                                    : theme.fontColor[100],
                        }}
                    />
                }
                callbackFunction={() => {
                    useDataStore.getState().set.note(props.noteID, {
                        folderID: props.folderID,
                    });
                }}
                disabled={noteFolder === props.folderID}
            />
        </div>
    );
}
